import { Link } from '@/components/ui'
import type { CellContext } from '@/components/ui/table/types'
import type { Project } from '@/modules/projects'
import { getProjectPath } from '@/utils'

export const NameCell = (cell: CellContext<Project, string>) => {
  const project = cell.row.original

  return (
    <Link
      to={getProjectPath(project)}
      className="flex items-center text-blue-7 font-medium h-full py-3"
    >
      <span>{cell.getValue()}</span>
    </Link>
  )
}
